// extracted by mini-css-extract-plugin
export var captionVideo = "gallery-module--captionVideo--f81b6";
export var imageBox = "gallery-module--imageBox--787a0";
export var playVideo = "gallery-module--playVideo--b1f83";